var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('div',{staticClass:"page-title-box d-md-flex justify-content-between mb-3"},[_c('div',[_c('h3',[_vm._v(_vm._s(_vm.t('Matriz')))]),_c('p')])]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('Matriz',{attrs:{"data":_vm.matriz}})],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }